import * as ng from 'angular';

export const RepeatDirective = () => (<angular.IDirective>{
    link: (scope: any, element: JQLite, attrs: any) => {
        if (scope.$last) {
            $(element).closest('#table-items').css('display', 'table');
        }
    }
});



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/commons/directives/repeat-directive/repeat-directive.directive.ts